import { render, staticRenderFns } from "./paymentDetail.vue?vue&type=template&id=0418b028&scoped=true&"
import script from "./paymentDetail.vue?vue&type=script&lang=ts&"
export * from "./paymentDetail.vue?vue&type=script&lang=ts&"
import style0 from "./paymentDetail.vue?vue&type=style&index=0&id=0418b028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0418b028",
  null
  
)

export default component.exports